import React from "react";

export default function InputPesquisa({ value, onChange, className = "" }) {
  return (
    <input
      type="text"
      value={value}
      onChange={onChange}
      className={`border-b border-gray-400 bg-transparent
                  focus:outline-none focus:border-b-2 focus:border-[#0088e3]
                  text-gray-700 h-[26px] text-sm px-2
                  transition-all font-comfortaa text-center ${className}`}
    />
  );
}
